/**
 * This is separate from the panel-config to avoid circular reference - the grid uses this for saved views
 */
export const ExternalFileManagerKey = 'external-file-manager-qas1y' // <-- DO NOT CHANGE THIS. The layout manager depends on this value.
export const FileManagerNodeGridKey = `${ExternalFileManagerKey}-NodeGrid`
export const PositionGridKey = `${ExternalFileManagerKey}-PositionGrid`
export const TransactionGridKey = `${ExternalFileManagerKey}-TransactionGrid`
